import { setToModel } from '@/utils/objects'
import { ServiceError } from '@/services/Service'
import axios from 'axios'

export default {
  install (Vue) {
    Object.defineProperties(Vue.prototype, {
      staticImage: {
        get () {
          return (name) => {
            return `${!this.$route.matched.length ? 'app/' : this.$route.matched.map(_ => '../')}img/${name}`
          }
        }
      },
      copyObjectProps: {
        get () {
          return setToModel
        }
      },
      parseJsTemplate: {
        get () {
          return (object) => {
            for (let key in object) {
              if (object[key]) {
                let val = object[key]
                if (typeof val === 'string' && object[key].indexOf('${') !== -1) {
                  // eslint-disable-next-line
                  object[key] = new Function('data, root', `return \`${object[key]}\``)
                } else if (typeof object[key] === 'object' && Object.keys(object[key]).length) {
                  this.parseJsTemplate(object[key])
                }
              }
            }
            return object
          }
        }
      },
      checkEs6AndRun: {
        get () {
          return (val, data = null) => {
            if (typeof val === 'string' && val.indexOf('${') !== -1) {
              // eslint-disable-next-line
              let func = new Function('data, root', `return \`${val}\``)
              return func(data, this.$root)
            } else if (typeof val === 'function') {
              return val(data, this.$root)
            } else {
              return val
            }
          }
        }
      },
      checkJsTemplate: {
        get () {
          return (object, data = null) => {
            return (object && typeof object === 'function') ? object(data, this.$root) : object || data
          }
        }
      },
      // REQUESTS
      globalMixinErrorResponse: {
        get () {
          return (error, defaultMessage) => {
            let message
            if (error) {
              if (error.response) {
                if (typeof error.response === 'object') {
                  if (typeof error.response.data === 'object') {
                    message = error.response.data.message || undefined
                  } else if (typeof error.response.data === 'string') {
                    message = error.response.data
                  }
                } else if (typeof error.response === 'string') {
                  message = error.response
                }
              }
              if (error instanceof ServiceError) {
                return error.message
              }
            }
            return message || defaultMessage
          }
        }
      },
      requestErrorHandler: {
        get () {
          return (error, DefaultMessage) => {
            if (!axios.isCancel(error)) {
              this.$notify.error({
                title: 'Error',
                message: this.globalMixinErrorResponse(error, DefaultMessage || this.L10n('general-error')),
                position: 'bottom-right'
              })
            }
          }
        }
      },
      validateErrorHandler: {
        get () {
          return (error, DefaultMessage) => {
            this.$notify.error({
              title: this.L10n('validate-error'),
              message: (error && error.message) || '',
              position: 'bottom-right'
            })
          }
        }
      },
      globalMixinSuccessResponse: {
        get () {
          return (response, defaultMessage) => {
            let message
            if (response) {
              if (typeof response === 'object') {
                if (typeof response.data === 'object') {
                  message = response.data.message || undefined
                } else if (typeof response.data === 'string') {
                  message = response.data
                }
              } else if (typeof response === 'string') {
                message = response
              }
            }
            return message || defaultMessage
          }
        }
      },
      requestSuccessHandler: {
        get () {
          return (response, DefaultMessage) => {
            this.$notify.success({
              title: 'Success',
              message: this.globalMixinSuccessResponse(response, DefaultMessage),
              position: 'bottom-right'
            })
          }
        }
      },
      // LABELS
      L10n: {
        get () {
          return (labelKey, languageID = undefined) => {
            let lowerLabelKey = String(labelKey).toLowerCase()
            let currentUser = this.$store.getters.get('currentUser')
            let langID = (currentUser && currentUser.languageID !== undefined) ? currentUser.languageID : languageID || 1
            let value = this.$store.getters.get('L10n')
            if (value && value[langID] && value[langID][lowerLabelKey]) {
              return value[langID][lowerLabelKey].title
            } else {
              // eslint-disable-next-line
              console.warn(`Labels: not found labelKey - ${lowerLabelKey} in languageID - ${langID}`)
              return lowerLabelKey
            }
          }
        }
      },
      permission: {
        get () {
          /**
           * @desc
           * @param {Object} Permissions - permissions for current user {isAllowEdit: true, isAllowView: false}
           * @param {String} Value - list of fields => 'isAllowEdit, !isAllowView, ${data.id === value}'
           * @return {Boolean}
           */
          return (Permissions, Value, mode = 'every') => {
            if (!Permissions || !Value) {
              return true
            }
            Value = String(Value)
            let valueBool = true
            let values = Value
              ? Value.replace(/\s/g, '').split(',')
              : []
            const checkCallback = (val) => {
              if (/^\${/g.test(val)) {
                return this.checkEs6AndRun(val, Permissions) === 'true'
              } else if (Permissions[val] === undefined) {
                console.warn(`Permission ${val} is exist`)
                return true
              } else if (val[0] === '!') {
                val = val.slice(1)
                return !Permissions[val]
              } else {
                return Permissions[val]
              }
            }
            // Check values
            if (values.length && mode === 'every') {
              valueBool = values.every(checkCallback)
            } else if (values.length && mode !== 'every') {
              valueBool = values.some(checkCallback)
            }
            return valueBool
          }
        }
      },
      // VALIDATION RULES
      getValidationRule: {
        get () {
          return (types = '') => {
            let templates = {
              required: {
                required: true,
                message: this.L10n('required'),
                trigger: 'blur',
                validator: (rule, value, cb) => {
                  if (!value) {
                    cb(new Error(rule.message))
                  } else {
                    cb()
                  }
                }
              },
              requiredSelect: {
                required: true,
                message: this.L10n('required'),
                trigger: ['change', 'blur']
              },
              minLength: {
                min: 2,
                message: this.L10n('length-min-error'),
                trigger: 'blur'
              },
              maxLength50: {
                message: this.L10n('length-max-error'),
                trigger: 'blur',
                validator: (rule, value, cb) => {
                  if (value && value.length > 50) {
                    cb(new Error(rule.message))
                  } else {
                    cb()
                  }
                }
              },
              email: {
                type: 'email',
                message: this.L10n('invalid-email'),
                trigger: ['change', 'blur'],
                validator: (rule, value, callback) => {
                  if (!value) {
                  }
                  // eslint-disable-next-line
                  if (/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(value)) {
                    callback()
                  } else {
                    callback(new Error(rule.message))
                  }
                }
              },
              number: {
                message: this.L10n('invalid-number'),
                trigger: ['change', 'blur'],
                validator: (rule, value, callback) => {
                  let message = this.L10n('invalid-number')
                  if (!value) {
                    callback()
                  } else if (!isNaN(parseFloat(value))) {
                    callback()
                  } else {
                    callback(new Error(message))
                  }
                }
              },
              numberInteger: {
                trigger: ['change', 'blur'],
                validator: (rule, value, callback) => {
                  let message = this.L10n('invalid-number-integer')
                  if (!value) {
                    callback()
                  } else if (/^\d+$/.test(value)) {
                    callback()
                  } else {
                    callback(new Error(message))
                  }
                }
              },
              url: {
                type: 'url',
                message: this.L10n('invalid-url'),
                trigger: ['change', 'blur']
              },
              code: {
                trigger: ['submit'],
                validator: (rule, value, callback) => {
                  if (value) {
                    if (!isNaN(parseFloat(value)) && isFinite(value)) {
                      if (String(value).length === 4) {
                        callback()
                      } else {
                        callback(new Error(this.L10n('invalid-code-four-digit')))
                      }
                    } else {
                      callback(new Error(this.L10n('invalid-code-four-digit')))
                    }
                  } else {
                    callback(new Error(this.L10n('required')))
                  }
                }
              }
            }
            return types.split(',').map(type => templates[type] || {})
          }
        }
      },
      setFocusElement: {
        get () {
          return (Self_, Reference = 'firstField') => {
            this.$nextTick(() => {
              if (Self_.$refs[Reference]) {
                Self_.$refs[Reference].focus()
              } else {
                setTimeout(() => {
                  if (Self_.$refs[Reference]) {
                    Self_.$refs[Reference].focus()
                  }
                }, 100)
              }
            })
          }
        }
      },
      /**
       * @desc create random string
       * @param length {Number}
       * @param chars {String} templates ('a', '#aA' ...)
       * @return {String}
       */
      randomString: {
        get () {
          return (length = 10, chars = 'aA') => {
            let mask = ''
            if (chars.indexOf('a') > -1) mask += 'abcdefghijklmnopqrstuvwxyz'
            if (chars.indexOf('A') > -1) mask += 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
            if (chars.indexOf('#') > -1) mask += '0123456789'
            if (chars.indexOf('!') > -1) mask += '~`!@#$%^&*()_+-={}[]:";\'<>?,./|\\'
            let result = ''
            for (let i = length; i > 0; --i) result += mask[Math.floor(Math.random() * mask.length)]
            return result
          }
        }
      },
      // INPUTS
      valueTrimLeft: {
        get () {
          return (str) => String(str).trimLeft()
        }
      },
      valueEmptyToNull: {
        get () {
          return (value) => {
            return value === '' || value === undefined ? null : value
          }
        }
      },
      valueInteger: {
        get () {
          return (val) => {
            let result = parseInt(val)
            return isNaN(result) ? null : result
          }
        }
      },
      valueNumber: {
        get () {
          return (val) => {
            let result = this.$numeral(val)
            const value = result.value()

            result = isNaN(value) ? 0 : result.input()

            if (String(result).endsWith('.') || String(result).endsWith('.0')) {
              return result
            }

            result = parseFloat(result)
            return isNaN(result) ? 0 : result
          }
        }
      },
      // Query
      /**
       * @desc Get query param from current rout
       * @param key {String} - query param name
       * @param converter {Function} - function for convert param value
       * @param defaultValue {any} - default value, witch return if key param was not in the current rout
       * @returns {any|undefined}
       */
      getQueryParam: {
        get () {
          return (key, converter = String, defaultValue = undefined) => {
            if (typeof (converter) !== 'function') {
              // eslint-disable-next-line
              console.error(new Error(`converter must be a function got a ${typeof (converter)}`))
              return defaultValue
            }
            let query = this.$router.currentRoute.query
            return query[key] !== undefined ? converter(query[key]) : defaultValue
          }
        }
      },
      /**
       * @desc Replace string with "" to null where kay has ..ID
       * @param data {Object} - the data for send
       * @returns {Object}
       */
      correctDataWithFieldID: {
        get () {
          return (data) => {
            return this.$_.reduce(data, (result, value, key) => {
              result[key] = (/ID/g.test(key) && value === '') ? null : value
              return result
            }, {})
          }
        }
      }
    })
  }
}
